// defines functions that are used in more than 1 place
import { fetchSeqIDDistance } from "./phyloFetch";

export function noSeq(ptObj, nameMap) {
  //console.log('noSeq', ptObj, nameMap)
  // extracts potential sources with no seq_ids
  if (!nameMap) {
    return [];
  } else {
    const namesSet = new Set(Object.values(nameMap).flat());
    return (
      ptObj.source_list
        .flatMap((item) =>
          item.sources.filter((source) => source.seq_id === null)
        )
        .map((source) => `${source.firstname} ${source.surname}`)
        // because a particular ptObj doesn't containt a seqId does not mean another sample doesn't
        .filter((name) => !namesSet.has(name))
    );
  }
}

export function outsideTree(source_names, leaf_names, noSeq) {
  // extracts sources who are not present on the tree and who have sequence data
  //console.log('outsideTree', source_names, leaf_names, noSeq)
  return source_names.filter(
    (name) => !(name in leaf_names) && !noSeq.includes(name)
  );
}

export function srceNames(ptObj) {
  return ptObj.source_list.flatMap((item) =>
    item.sources.map((source) => ({
      name: `${source.firstname} ${source.surname}`,
      seq_id: source.seq_id,
      micro_id: source.micro_id,
    }))
  );
}

export function srceSeqIds(ptObj) {
  return ptObj.source_list.flatMap((item) =>
    item.sources
      .filter((source) => source.seq_id !== null)
      .map((source) => `${source.seq_id}`)
  );
}

export function buildConstraintSeqIds(seqIds, indexSeqId) {
  const unique = new Set();
  if (indexSeqId !== null && indexSeqId !== undefined) {
    unique.add(String(indexSeqId));
  }

  if (Array.isArray(seqIds)) {
    seqIds.forEach((id) => {
      if (id !== null && id !== undefined && id !== "") {
        unique.add(String(id));
      }
    });
  }

  return Array.from(unique);
}

export async function fetchSNPDistance(api, index_seq_id, withSeqId) {
  // Extract seq_ids from the withSeqId array
  const seq_ids = withSeqId.map(item => item.seq_id);

  try {
    // Fetch distances from the API
    const distances = await fetchSeqIDDistance(api, index_seq_id, seq_ids);
    console.log("Distances:", distances);

    // Map distances back to the objects in withSeqId
    return withSeqId.map((item, index) => {
      return {
        ...item,
        dist: distances[index].dist // Assuming the order of distances matches the order of seq_ids
      };
    });
  } catch (error) {
    console.error("Error adding distance property:", error);
    throw error; // Re-throw the error after logging it
  }
}
